import {
  Container,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress,
  Box,
  Link as MuiLink,
  Grid,
  Snackbar,
} from "@mui/material";

import { Link } from "react-router-dom";
import { useState } from "react";
import { useForgotPasswordMutation } from "../../Apis/authApi"; // you'll need to create this mutation
let logo2 = require("../../Assets/Images/logoDEC.png");

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error" | "info";
  }>({ open: false, message: "", severity: "info" });

  const [forgotPassword] = useForgotPasswordMutation();

    const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      await forgotPassword({ email }).unwrap();
      setSubmitted(true);
    } catch (err: any) {
      setError(
        err?.data?.errorMessages?.[0] || "Something went wrong. Try again."
      );
      setSnackbar({
          open: true,
          message: error,
          severity: "error",
        });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      maxWidth="lg"
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Grid container spacing={1} alignItems="center">
        <Grid size={{ xs: 12, md: 12, lg: 12 }}>
          <Card
            elevation={3}
            sx={{
              borderRadius: 4,
              border: "1px solid #ddd",
              p: 1,
            }}
          >
              <Box
          sx={{
            textAlign: "center",
            mb: 2,
            borderBottom: "2px solid rgba(81, 35, 132, 1)",
          }}
        >
          <Box
            component="img"
            src={logo2}
            alt="Logo"
            sx={{
              maxHeight: 40,
              display: "inline-block",
              pb: 0.5, // small space between image and underline
            }}
          />
        </Box>
        
            <CardContent sx={{ p: 1 }}>
              
              {submitted ? (
                <Alert severity="success">
                  If the email exists, a password reset link has been sent.
                  Please check your inbox.
                </Alert>
              ) : (
                <>
                  <Typography
                    variant="h6"
                    align="left"
                    gutterBottom
                    sx={{  fontWeight: "bold" }}
                  >
                    Reset Password
                  </Typography>

                  <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
                    <TextField
                      label="Email"
                      type="email"
                      variant="outlined"
                      fullWidth
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      sx={{ mb: 3 }}
                    />

                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      disabled={loading}
                      sx={{
                        backgroundColor: "#eb3c96",
                        color: "white",
                        "&:hover": { backgroundColor: "#d83485" },
                        mb: 2,
                        py: 1.2,
                      }}
                    >
                      {loading ? (
                        <>
                          <CircularProgress
                            size={20}
                            sx={{ color: "white", mr: 1 }}
                          />
                          Sending...
                        </>
                      ) : (
                        "Send Reset Link"
                      )}
                    </Button>

                    <MuiLink
                      component={Link}
                      to="/login"
                      underline="none"
                      sx={{
                        display: "block",
                        textAlign: "center",
                        color: "rgba(81, 35, 132, 1)",
                        fontWeight: 500,
                      }}
                    >
                      Back to Login
                    </MuiLink>
                  </Box>
                </>
              )}
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: false, md: 3, lg: 2 }} />
      </Grid>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}
